import LpaTemplate from 'frontend/communications/dto/lpaTemplate'
import LpaTemplateUpload from 'frontend/communications/dto/lpaTemplateUpload'
import { _delete, _get, _patch, _post, _save, getUrlQueryParameterFromObject } from 'frontcore/utils/communications/apiClient'
import { _saveBinary  } from './apiClient'
const URL_BASE_TEMPLATES = 'templates'
const URL_BASE_AUDIT_CONFIG_BY_ROLES = 'audit-config-by-roles'
const URL_BASE_AUDIT_CONFIG_BY_TEAMS = 'audit-config-by-teams'
const URL_BASE_TEMPLATE_LEVEL_ITEMS = 'template_level_items'
const URL_BASE_PERCENTAGE_RULES = 'percentage-rules'
const URL_BASE_PERCENTAGE_SCORES = 'percentage-scores'
const URL_BASE_TEMPLATE_SUBSOURCES = 'configurations/templates-subsources'
export const URL_BASE_AUDIT_SUBSOURCES = 'subsources'
export const URL_BASE_AUDIT_SUBSOURCES_BY_SOURCE = 'subsources-by-source'

export function getAuditConfigByRoles (source) {
  const url = `${URL_BASE_AUDIT_CONFIG_BY_ROLES}/?source=${source}`
  return _get(url)
}

export function getAuditConfigByTeams (source) {
  const url = `${URL_BASE_AUDIT_CONFIG_BY_TEAMS}/?source=${source}`
  return _get(url)
}

export function updateAuditConfigByTeam (id, data) {
  const url = `${URL_BASE_AUDIT_CONFIG_BY_TEAMS}/${id}/`
  return _patch(url, data)
}

export function updateAuditConfigByRole (id, data) {
  const url = `${URL_BASE_AUDIT_CONFIG_BY_ROLES}/${id}/`
  return _patch(url, data)
}

export function getTemplates (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_TEMPLATES}/?${queryParams}` : `${URL_BASE_TEMPLATES}/`
  return _get(url)
}

export function getLPAListTemplates (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `master-audit-templates-list/?${queryParams}`
  return _get(url)
}

export function getTemplate (templateId, parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = queryParams ? `${URL_BASE_TEMPLATES}/${templateId}/?${queryParams}` : `${URL_BASE_TEMPLATES}/${templateId}/`
  return _get(url)
}

export function getLPAsCriteriaInTemplate (templateId) {
  const url = `${URL_BASE_TEMPLATES}/${templateId}/criteria_in_template/`
  return _get(url)
}

export function getLPAsCriterion (templateId, criterionId, parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const base_url = `${URL_BASE_TEMPLATES}/${templateId}/criteria/${criterionId}`
  const url = queryParams ? `${base_url}/?${queryParams}` : `${base_url}/`
  return _get(url)
}

export function getScores (source = null) {
  let url = `${URL_BASE_TEMPLATES}/scores/`
  if (source) { url += `?source=${source}` }
  return _get(url)
}

export function saveExcelTemplate (data, source) {
  const url = `${URL_BASE_TEMPLATES}/excel/?source=${source}`
  return _saveBinary(url, data)
}

export function saveCurrentTemplate (source) {
  const url = `${URL_BASE_TEMPLATES}/?format=excel&active=true&source=${source}`
  return _saveBinary(url)
}

export function saveLPATemplate (lpaTemplate) {
  if (!(lpaTemplate instanceof LpaTemplate)) {
    throw new Error('lpaTemplate has to be instance of LpaTemplate DTO')
  }
  const payload = lpaTemplate.toApiPayload()
  const url = `${URL_BASE_TEMPLATES}/`
  return _save(url, payload, true)
}

export function saveCriterion (data, templateID, isNew, id) {
  let url = `${URL_BASE_TEMPLATES}/${templateID}/criteria/`
  if (id) { url += `${id}/` }
  return _save(url, data, isNew)
}

export function saveCriteriaInTemplate (data, templateID, isNew, id) {
  let url = `${URL_BASE_TEMPLATES}/${templateID}/criteria_in_template/`
  if (id) { url += `${id}/` }
  return _save(url, data, isNew)
}

export function removeCriterion (id, templateId) {
  const url = `${URL_BASE_TEMPLATES}/${templateId}/criteria/${id}/`
  return _delete(url)
}

export function removeCriterionInTemplate (id, templateId) {
  const url = `${URL_BASE_TEMPLATES}/${templateId}/criteria_in_template/${id}/`
  return _delete(url)
}

export function patchCriteriaInTemplate (templateId, data) {
  const url = `${URL_BASE_TEMPLATES}/${templateId}/criteria_in_template/`
  return _patch(url, data)
}

export function patchCriterionInTemplate (id, templateId, data) {
  const url = `${URL_BASE_TEMPLATES}/${templateId}/criteria_in_template/${id}/`
  return _patch(url, data)
}

export function patchCriterion (data, templateID, id) {
  const url = `${URL_BASE_TEMPLATES}/${templateID}/criteria/${id}/`
  return _patch(url, data)
}

export function patchTemplate (templateID, data) {
  const url = `${URL_BASE_TEMPLATES}/${templateID}/`
  return _patch(url, data)
}

export function createTemplateLevelItem (data) {
  const url = `${URL_BASE_TEMPLATE_LEVEL_ITEMS}/`
  return _save(url, data, true)
}

export function updateTemplateLevelItem (id, {familyName, templateLevel, order}) {
  const url = `${URL_BASE_TEMPLATE_LEVEL_ITEMS}/${id}/`
  return _patch(url, {text: familyName, template_level: templateLevel, order: order})
}

export function deleteTemplateLevelItem (id) {
  const url = `${URL_BASE_TEMPLATE_LEVEL_ITEMS}/${id}/`
  return _delete(url)
}

export function patchTemplateLevelItem (templateID, templateLevelItemID, data) {
  const url = `${URL_BASE_TEMPLATES}/${templateID}/template_level_item/${templateLevelItemID}/`
  return _patch(url, data)
}

export function patchTemplateLevelItems (templateId, data) {
  const url = `${URL_BASE_TEMPLATES}/${templateId}/template_level_item/`
  return _patch(url, data)
}

export function updateTemplate (templateId, data) {
  const url = `${URL_BASE_TEMPLATES}/${templateId}/`
  return _save(url, data, false)
}

export function deleteTemplate (id) {
  const url = `${URL_BASE_TEMPLATES}/${id}/`
  return _delete(url)
}

export function deleteTemplateVersion (id) {
  const url = `${URL_BASE_TEMPLATES}/?ids=${id}`
  return _delete(url)
}

export function deleteFamily (id) {
  const url = `${URL_BASE_TEMPLATE_LEVEL_ITEMS}/${id}/`
  return _delete(url)
}

export function getMasterAuditPercentageRules () {
  const url = `${URL_BASE_PERCENTAGE_RULES}/`
  return _get(url)
}

export function getMasterAuditPercentageScores () {
  const url = `${URL_BASE_PERCENTAGE_SCORES}/`
  return _get(url)
}

export function downloadLPAExcelExample (lpaTemplate) {
  if (!(lpaTemplate instanceof LpaTemplate)) {
    throw new Error('lpaTemplate has to be instance of LpaTemplate DTO')
  }
  const payload = lpaTemplate.toApiPayload()
  const url = `${URL_BASE_TEMPLATES}/importer/example/`
  return _saveBinary(url, payload)
}

export function loadLPAExcel (lpaTemplate) {
  if (!(lpaTemplate instanceof LpaTemplateUpload)) {
    throw new Error('lpaTemplate has to be instance of LpaTemplateUpload DTO')
  }
  const payload = lpaTemplate.toApiPayload()
  const url = `${URL_BASE_TEMPLATES}/importer/load/`
  return _post(url, payload)
}

export function updateAuditTemplateSubtypes (data, source) {
  const url = `${URL_BASE_TEMPLATE_SUBSOURCES}/${source}/`
  return _patch(url, data)
}

export function getAuditTemplateSubsourcesBySource (data) {
  const url = `${URL_BASE_TEMPLATE_SUBSOURCES}/?source=${data.source}`
  return _get(url)
}

export function getAuditTemplateSubsources () {
  const url = `${URL_BASE_TEMPLATE_SUBSOURCES}/`
  return _get(url)
}

export function getAuditSubSources () {
  const url = `${URL_BASE_AUDIT_SUBSOURCES}/`
  return _get(url)
}

export function getAuditSubSourcesBySource (source) {
  const url = `${URL_BASE_AUDIT_SUBSOURCES_BY_SOURCE}/${source}/`
  return _get(url)
}

export function exportTemplateById (templateID) {
  const url = `${URL_BASE_TEMPLATES}/exporter/`
  return _saveBinary(url, {template_id: templateID})
}
